export default __webpack_public_path__ + "static/media/gothenburg_background_l1.bb9dda7a.jpg";